import {
  RECEIVE_FOOTER_DATA,
  RECEIVE_FOOTER_DATA_ERROR,
  SWITCH_TO_DESKTOP,
  SWITCH_TO_MOBILE,
  PAGE_RELOADED,
} from '../actions/footer';

export const initialState = {
  sectionLinks: [],
  socialLinks: [],
  appLinks: [],
  mhraLogo: '',
  cookieLink: null,
  error: null,
  pageReloading: false,
};

export default function footer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_FOOTER_DATA: {
      // removing google plus
      const { footerData } = action;
      footerData.socialLinks = action.footerData.socialLinks.filter(link => link.id !== 'gplus');
      return { ...state, ...footerData };
    }
    case RECEIVE_FOOTER_DATA_ERROR: {
      return { ...initialState, error: action.error };
    }
    case SWITCH_TO_DESKTOP: {
      return { ...state, stickToDesktop: true, pageReloading: true };
    }
    case SWITCH_TO_MOBILE: {
      return { ...state, stickToDesktop: false, pageReloading: true };
    }
    case PAGE_RELOADED: {
      return { ...state, pageReloading: false };
    }
    default:
      return state;
  }
}
